import { render, staticRenderFns } from "./SelectAccountType.vue?vue&type=template&id=d34970ba&lang=pug"
import script from "./SelectAccountType.vue?vue&type=script&lang=js"
export * from "./SelectAccountType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports